import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { isInArray } from '../../../../core/util/is-in-array';
import { omit } from '../../../../core/util/utils';
import { Form } from '../../../../vas/business-objects/form/form.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const groupRemoveReducer = (
    state = initialState,
    action: actions.GroupRemove
): State => {
    if (
        !state.group.ids.find(id => id === action.payload.group.id)
    ) {
        return state;
    }

    const dirtyFormIds = state.form.ids
        .filter(id => {
            const form = state.form.entities[id];
            return form.groups.indexOf(action.payload.group.id) !== -1;
        });

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            forms: dirtyFormIds.reduce(
                (acc, id) => arrayPushUnique(acc, id),
                state.dirtyIds.forms
            )
        },
        control: (() => {

            const groupControlIds = [];
            const groupControls = [];

            state.control.ids
                .map(id => state.control.entities[id])
                .filter(c => c.group === action.payload.group.id)
                .forEach(control => {
                    groupControlIds.push(control.id);
                    groupControls.push(control);
                });

            return {
                ids: state.control.ids
                    .filter(id => !isInArray(id, groupControlIds)),
                entities: omit(
                    state.control.entities,
                    groupControlIds
                ),
                deleted: groupControls
            };
        })(),
        group: {
            ...state.group,
            ids: state.group.ids
                .filter(id => id !== action.payload.group.id),
            entities: omit(
                state.group.entities,
                action.payload.group.id
            ),
            deleted: [...state.group.deleted, action.payload.group]
        },
        form: {
            ...state.form,
            entities: state.form.ids
                .map(id => {
                    const form = state.form.entities[id];

                    if (
                        form.groups
                            .find(gid =>
                                gid !== action.payload.group.id)
                    ) {
                        return form;
                    }

                    return new Form({
                        ...form,
                        groups: form.groups
                            .filter(
                                gid =>
                                    gid !== action.payload.group.id
                            )
                    });
                })
                .reduce((forms, form) => {
                    forms[form.id] = form;
                    return forms;
                }, {})
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/group-remove.reducer.ts